import ReactLoading from 'react-loading';

export default function Loader({ type, color }) {
    return (
        <div>
            <ReactLoading type={type} color={color} height={50} width={50} />
        </div>
    )
}
